import Body from "./Body";
import TimeFilter from "./TimeFilter";

export const Components = {
  Body,
  TimeFilter,
};
